/* eslint-disable */
import React from 'react';

const resendIcon = () => (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4.33237" y="7.01151" width="14.3383" height="8.9766" rx="2.35" stroke="#515967" stroke-width="1.3" />
        <path d="M5.00024 7.5L11.2766 11.2765L18.0002 7.5" stroke="#515967" stroke-width="1.3" />
        <path d="M1 8.14894V5.76596C1 4.97163 1.35745 3.38298 2.78723 3.38298H9.14184M7.95035 1L9.93617 3.38298L7.95035 5.76596" stroke="#515967" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M22 14.8511V17.234C22 18.0284 21.6426 19.617 20.2128 19.617H13.8582M15.0496 22L13.0638 19.617L15.0496 17.234" stroke="#515967" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export default resendIcon;